import React from 'react';
import { Link } from 'react-router-dom';
import GenericQuiz from '../components/GenericQuiz';
import rstQuizData from '../data/rst';

const RSTPage = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
      <header className="mb-6 sm:mb-8">
        <div className="flex items-center mb-4">
          <Link
            to="/"
            className="text-blue-600 hover:text-blue-700 flex items-center space-x-2 text-sm sm:text-base mb-2"
          >
            <span>←</span>
            <span>Back to Home</span>
          </Link>
        </div>
        
        <div className="text-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            {rstQuizData.title}
          </h1>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            {rstQuizData.description}
          </p>
        </div>
      </header>

      <div className="max-w-4xl mx-auto">
        <GenericQuiz quiz={rstQuizData} />
      </div>

      <div className="max-w-4xl mx-auto mt-8 text-center">
        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-3">
            About the RS System
          </h3>
          <p className="text-gray-600 text-sm">
            The RS system is used in amateur radio to report signal quality. RS stands for 
            <strong> Readability</strong> (R1-R5) and <strong>Signal Strength</strong> (S1-S9). 
            Readability indicates how well the signal can be understood, while Signal Strength 
            indicates how strong the received signal is. A report like "59" means perfect readability 
            and extremely strong signals - the best possible signal report.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RSTPage;